<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'reservation'">
    <div class="modal-header">
        <h3 class="modal-title">{{ product.name }}</h3>
    </div>
    <div class="modal-body reservation-modal" v-show="isVisible('reservation')">
        <div class="row">
            <div class="col-xs-12">
                <template v-if="$store.getters['reservations/minuteRules'].length === 0">
                    <div class="pull-right" v-show="availableResources.length > 0 && activeReservation.availableQuantity === 1">
                        <div v-show="!selectAdditionalResources">
                            <button 
                                class="btn btn-default btn-sm" 
                                @click="selectAdditionalResources = true">
                                <i class="glyphicon glyphicon-plus text-success"></i>
                            </button>
                        </div>
                        <div v-show="selectAdditionalResources">
                            <button 
                                class="btn btn-default btn-sm" 
                                @click="selectAdditionalResources = false">
                                <i class="glyphicon glyphicon-chevron-right text-success"></i>
                            </button>
                            <button class="btn btn-default btn-sm"
                                v-for="(resObj, index) in availableResources"
                                :key="index"
                                @click="toggleAdditionalBlock(index, true)">
                                {{ resObj.block.resource.resourceName }}
                            </button>
                        </div>
                    </div>
                </template>

                <h2 style="margin-bottom: 15px;">
                    {{ activeReservation.title }}
                </h2>
                <p class="pull-left" style="font-size: 20px;">
                    <i class="glyphicon glyphicon-time"></i>
                    {{ $_formatDateTime($_dateFormat.DATETIME_DAY_NAME_SHORT, activeReservation.start) }}
                    {{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, activeReservation.start) }}
                    -
                    {{ $_formatDateTime(activeReservation.overNight ? $_dateFormat.DATETIME_DMYHI : $_dateFormat.DATETIME_HI, activeReservation.end) }}
                </p>
                <div class="pull-right" style="width: 120px;" v-show="activeReservation.availableQuantity > 1 && activeReservation.maxQuantity > 1">
                    <div class="input-group" style="">
                        <span class="input-group-btn">
                            <button @click="activeReservation.adjustOrderQuantity(false)" class="btn btn-default" style="margin-right: -1px;">-</button>
                        </span>
                        <input type="text" :value="activeReservation.orderQuantity" class="form-control" style="height: 34px; text-align: center;" :disabled="true" />
                        <span class="input-group-btn">
                            <button @click="activeReservation.adjustOrderQuantity(true, true)" class="btn btn-default" style="margin-left: -1px;">+</button>
                        </span>
                    </div>
                </div>

                <div class="clearfix"></div>
                
                <template v-if="$store.getters['reservations/minuteRules'].length">
                    <MinuteOptions />
                </template>
                <template v-else>
                    <DurationOptions 
                        v-show="activeReservation.minDuration != activeReservation.maxDuration || adminMode"
                        @selectDuration="selectDuration($event.index)"
                        @toggleAdditionalBlock="toggleAdditionalBlock($event.index, $event.add)" />
                </template>                
                
                <div class="pull-left">
                    <div v-show="adminMode 
                        && activeReservation.availableQuantity === 1
                        && !activeReservation.soldReservationTimeId">
                        <label>
                            <input type="checkbox" 
                                   v-model="activeReservation.recurringReservation"/>
                            {{ $_locale('save as a recurring reservation') }}
                        </label>
                        <SelectShareOwner 
                            ref="shareOwner" 
                            v-show="activeReservation.recurringReservation" />
                    </div>
                    <div v-show="enableMembershipStamps">
                        <h5>{{ $_locale('available serial tickets') }}:</h5>
                        <div v-for="stamp in availableStamps"
                            :key="stamp.categoryId">
                            <label style="font-weight: normal;">
                                <input type="checkbox" 
                                    :checked="membershipStampsQuantity[stamp.categoryId]" 
                                    :disabled="isStampDisabled(stamp)"
                                    @change="membershipToggle(stamp)">
                                <span style="margin-left: 7px;">{{ stamp.name }} ({{ stamp.usableQuantity - (!!membershipStampsQuantity[stamp.categoryId] ? membershipStampsQuantity[stamp.categoryId].quantity : 0) }})</span>
                            </label>
                        </div>
                    </div>
                </div>
                <PriceSummary class="pull-right" :additionalReservations="additionalReservations" ref="priceSummary" />
                <div class="clearfix"></div>
                <div v-show="!activeReservation.recurringReservation && availableAdditionalResources.length > 0">
                    <h4>{{ $_locale('options') }}</h4>
                    <AdditionalResourceHandler ref="resourceHandler" />
                </div>
            </div>
        </div>
        <div class="" v-show="activeReservation.recurringReservation">
            <h4>{{ $_locale('recurring reservation') }}</h4>
            <div class="row">
                <div class="col-xs-12">
                    {{ $_locale('every %s until date', true, activeReservation.start.format('dddd')) }}
                    <input type="text" class="form-control" ref="dateInput" />
                    <p>{{ activeReservation.recurringDates.length + 1 }} {{ $_locale('weeks selected', false) }}</p>
                </div>
                <div class="col-xs-12">

                </div>
            </div>
        </div>
    </div>
    
    <template v-if="isVisible('reservationList')">
        <div class="modal-body reservation-modal">
            <reservations-list :reservation="activeReservation"></reservations-list>
        </div>
        <div class="modal-footer">
            <button class="btn btn-default pull-left" @click="toggleActive('reservationList',false)">{{ $_locale('cancel') }}</button>
        </div>
    </template>
    
    <template v-if="isVisible('disableTime')">
        <div class="modal-body reservation-modal">
            <div class="pull-right" style="width: 200px;" v-show="activeReservation.availableQuantity > 1">
                <h6>Tarkenna kuinka monta paikkaa poistetaan</h6>
                <div class="input-group" style="">
                    <span class="input-group-btn">
                        <button @click="activeReservation.adjustOrderQuantity(false)" class="btn btn-default" style="margin-right: -1px;">-</button>
                    </span>
                    <input type="text" :value="activeReservation.orderQuantity" class="form-control" style="height: 34px; text-align: center;" :disabled="true" />
                    <span class="input-group-btn">
                        <button @click="activeReservation.adjustOrderQuantity(true, true)" class="btn btn-default" style="margin-left: -1px;">+</button>
                    </span>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
                <label>{{ $_locale('reason') }}</label>
                <textarea class="form-control" v-model="disableTimeReason" maxlength="254"></textarea>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-default pull-left" @click="toggleActive('disableTime',false)">{{ $_locale('cancel') }}</button>
            <button class="btn btn-success" v-show="adminMode" @click="disableTimeBlocks()">{{ $_locale('confirm') }}</button>
        </div>
    </template>

    <div class="modal-footer" v-show="displayDefaultFooter">
        <template v-if="timeblockComments.length > 0">
            <div class="alert alert-info resource-comment" role="alert" 
                style="text-align:center;margin-top: 0;margin-bottom: 15px;">
                <p v-for="comment in timeblockComments" 
                    :key="comment.commentId">
                    <!--
                    <button class="btn btn-xs btn-danger pull-right" 
                        @click="deleteComment(comment)"
                        v-if="adminMode">
                        <i class="glyphicon glyphicon-trash"></i>
                    </button>
                    -->
                    <strong><i class="glyphicon glyphicon-info-sign"></i></strong> {{ comment.comment }}
                </p>
            </div>
        </template>
        <button class="btn btn-default pull-left" @click="$store.commit('common/setModal', null)">{{ $_locale('close') }}</button>
        <button class="btn btn-default" v-show="adminMode && activeReservation.reservations.length" @click="toggleActive('reservationList',true)">{{ $_locale('reservations') }}</button>
        <button @click="setReservationSaleMode(activeReservation.soldReservationTimeId, 'offMarket')"
            v-show="adminMode && activeReservation.soldReservationTimeId" 
            class="btn btn-info">{{ $_locale('remove from market') }}</button>
        <button class="btn btn-warning" v-show="adminMode && !activeReservation.soldReservationTimeId" @click="toggleActive('disableTime',true)">{{ $_locale('disable times') }}</button>
        <button class="btn btn-success" @click="saveOrder">
            <span>{{ $_locale('make reservation') }}</span>
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'
import { durationToBlockCount } from '../common/ReservationService.js'
import CreateReservationMixin from '../common/CreateReservationMixin'
import PriceSummary from './PriceSummary.vue'
import AdditionalResourceHandler from './AdditionalResourceHandler.vue'
import SelectShareOwner from './SelectShareOwner.vue'
import DurationOptions from './DurationOptions.vue'
import MinuteOptions from './MinuteOptions.vue'

const { formatDateTime, dateFormat, getDateFormat } = window.wisenetwork;
const initialData = () => ({
    visible: 'reservation',
    disableTimeReason: '',
    recurringEndDate: moment(),
    selectAdditionalResources: false,
    selectedBlockIndex: 0,
    additionalReservations: [],
    preselectedStamp: false,
})
function getYearWeek(date) {
    // GGGG is the ISO week-year (may differ from calendar year YYYY at year boundaries),
    // ensuring the year and week number always refer to the same ISO week.
    return date.format('GGGG-WW')
}

export default {
    emits: ['processing'],
    components: {
        PriceSummary,
        AdditionalResourceHandler,
        SelectShareOwner,
        DurationOptions,
        MinuteOptions,
    },
    mixins: [ CreateReservationMixin ],
    data: initialData,
    computed: {
        ...mapGetters({
            timeTable: 'calendar/timeTable',
            product: 'ecom/product',
            activeReservation: 'calendar/activeReservation',
            availableAdditionalResources: 'calendar/availableAdditionalResources',
            selectedAdditionalResources: 'calendar/selectedAdditionalResources',
            reviewBlock: 'calendar/reviewBlock',
            adminMode: 'common/adminMode',
            generateReservation: 'reservations/generateReservation',
            weekMode: 'reservations/weekMode',
            date: 'reservations/date',
            resourceCommentsByBlock: 'reservations/resourceCommentsByBlock',
            modalIsOpen: 'common/modalIsOpen',
            mobile: 'common/mobile',
            availableStamps: 'memberships/availableStamps',
            membershipStamps: 'memberships/membershipStamps',
            membershipStampsQuantity: 'memberships/membershipStampsQuantity',
        }),
        enableMembershipStamps() {
            if (this.adminMode) return false;
            if (this.availableStamps.length === 0) return false;
            //if (this.preselectedStamp) return false;
            
            return true;
        },
        isStampDisabled() {
            const availableStampIds = this.availableStamps
                .map(row => row.categoryId)
            const stampsInUse = this.stampsInUse;
            const membershipStampsQuantity = this.membershipStampsQuantity;

            return (stamp) => {
                if (this.preselectedStamp) {
                    return true;
                }
                
                return !availableStampIds.includes(stamp.categoryId) 
                    || stampsInUse 
                    && !membershipStampsQuantity[stamp.categoryId]
            }
        },
        availableResources() {
            if (this.weekMode 
                    || this.activeReservation === null 
                    || this.activeReservation.placeholder) {
                return [];
            }
            const otherTables = this.timeTable.filter((table) => table.id !== this.activeReservation.tableId);
            const index = this.activeReservation.tableIndex;
            const selectedAdditionalReservations = this.additionalReservations.map(row => row.tableId)
            
            return otherTables
                    .filter((table) => !selectedAdditionalReservations.includes(table.id))
                    .filter((table) => this.reviewBlock({ index, table }))
                    .map((table) => this.generateReservation(index, table))
                    .sort((a,b) => a.tableId - b.tableId);
        },
        
        isVisible() {
            return (name) => name === this.visible; 
        },
        displayDefaultFooter() {
            return !this.isVisible('disableTime') 
                && !this.isVisible('reservationList')
        },
        stampsInUse() {
            if (this.adminMode) return false;

            return Object.keys(this.membershipStampsQuantity).length > 0;
        },
        stampsValid() {
            if (!this.stampsInUse) return true;

            const availableStampIds = this.availableStamps
                .map(row => row.categoryId)
            
            return Object.keys(this.membershipStampsQuantity)
                .reduce((prev, curr) => {
                    // if one is not valid, none of them is!!
                    if (!prev) return false;
                    if (!availableStampIds.includes(parseInt(curr))) return false;

                    const stamp = this.membershipStampsQuantity[curr];

                    return stamp.valid;
                }, true)
        },
        timeblockComments() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return [];
            }
            
            const { start, end, resource } = this.activeReservation
            
            return this.resourceCommentsByBlock({ start, end, resource });
        },
    },
    watch: {
        async modalIsOpen(val) {
            if (!val) {
                var data = initialData();
                Object.keys(data).forEach((key) => {
                    this[key] = data[key];
                })
            } else {
                const { start, end, resourceId } = this.activeReservation;
                const { preselectedCategoryId } = await this.$store.dispatch('memberships/init', { start, end, resourceId });

                if (preselectedCategoryId !== null) {
                    this.membershipToggle({ categoryId: preselectedCategoryId })
                }
            }
        },
        'activeReservation.recurringReservation': {
            handler(value) {
                if (!value) {
                    if (this.additionalReservations.length > 0) {
                        this.additionalReservations.forEach((resObj) => {
                            resObj.recurringReservation = false;
                        })
                    }
                    return;
                }
                
                const { daterangepicker } = window.wisenetwork
                const input = this.$refs.dateInput;
                const dayNameShort = getDateFormat(dateFormat.DATETIME_DAY_NAME_SHORT);
                const format = getDateFormat(dateFormat.DATETIME_DMY);
                
                if (this.mobile) {
                    input.readOnly = true;
                }

                daterangepicker(
                    input,
                    {
                        locale: { 
                            format: dayNameShort+' '+format,
                            daysOfWeek: _localeDates.dayNamesMin,
                            monthNames: _localeDates.monthNamesShort,
                            firstDay: 1,
                        },
                        //opens: 'right',
                        drops: 'up',
                        showWeekNumbers: true,
                        singleDatePicker: true,
                        showDropdowns: true,
                        startDate: this.activeReservation.start,
                    }, 
                    (startDate, endDate) => {
                        this.recurringEndDate = startDate;
                        const resObj = this.activeReservation;
                        const times = [];
                        const delta = resObj.start.clone(); // .startOf('isoWeek')
                        const end = this.recurringEndDate.clone();
                        const { overNight } = resObj;

                        if (overNight) {
                            end.add(24, 'hours')
                        }

                        let deltaYearWeek = getYearWeek(delta)
                        let endYearWeek = getYearWeek(end)
                        
                        while(deltaYearWeek < endYearWeek) {
                            delta.add(1, 'weeks')
                            times.push({
                                start: delta.clone().set({ 
                                    hour: resObj.start.format('H'), 
                                    minute: resObj.start.format('m') 
                                }).format('YYYY-MM-DD HH:mm:ss'),
                                end: delta.clone()
                                .add(overNight ? 24 : 0, 'hours')
                                .set({ 
                                    hour: resObj.end.format('H'), 
                                    minute: resObj.end.format('m')
                                }).format('YYYY-MM-DD HH:mm:ss')
                            })

                            deltaYearWeek = getYearWeek(delta)
                        }
                        //console.log('apply.daterangepicker', times);

                        resObj.recurringDates = times;

                        if (this.additionalReservations.length > 0) {
                            this.additionalReservations.forEach((resObj) => {
                                resObj.recurringReservation = true;
                                resObj.recurringDates = times;
                            })
                        }
                    }
                );
            }
        }
    },
    methods: {
        membershipToggle(stamp) {
            this.$store.dispatch(
                'memberships/toggleStampUsage', 
                { categoryId: stamp.categoryId }
            )
        },
        toggleActive(name, value) {
            this.visible = value ? name : 'reservation';

            if (name === 'disableTime') {
                this.activeReservation.setOrderQuantity(value ? this.activeReservation.availableQuantity : 0);
            }
        },
        adjustAdditionalResourceQuantity(add, row) {
            this.$store.commit('calendar/adjustAdditionalResourceQuantity', { add, row })
        },
        selectDuration(index) {
            [
                ...this.additionalReservations,
                this.activeReservation
            ].forEach((resObj) => {
                const block = resObj.availableBlocks[index];

                resObj.selectDuration(block, index)
            })
            this.$store.dispatch('calendar/updateAvailableAdditionalResources');
        },
        toggleAdditionalBlock(index, add) {
            // keep track of tableIds that are selected, then just filter to get these results
            // without mutating data
            if (add) {
                const resObj = { ...this.availableResources[index] };
                let selectedIndex = this.activeReservation.selectedIndex;
                
                if (resObj.availableBlocks.length - 1 < this.activeReservation.selectedIndex) {
                    selectedIndex = resObj.availableBlocks.length - 1;
                }
                
                this.additionalReservations.push(resObj);
                this.selectDuration(selectedIndex);
            } else {
                this.additionalReservations.splice(index, 1)
            }
        },
        disableTimeBlocks() {
            const disableTimeReason = this.disableTimeReason;
            if (!this.adminMode) {
                return;
            }
            let rows = this.activeReservation.format();

            if (this.additionalReservations.length > 0) {
                this.additionalReservations.forEach((resObj) => {
                    rows = rows.concat(resObj.format())
                })
            }

            const data = {
                forClient: true,
                products: rows.map(reservation => ({
                    productId: this.product.productId,
                    productVariantId: 0,
                    quantity: reservation.quantity * reservation.resources[0].quantity,
                    reservation
                })),
                extraInformation: disableTimeReason
            };
            
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$store.commit('common/setModal', null)
            
            EcomService.disableTime(data)
            .then((response) => {
                const data = response.data;

                if (data.success) {
                    this.$store.dispatch('reservations/onDateChange', this.date);
                    this.$_swal({ icon: 'success', title: _locale('time disabled').ucfirst() })
                } else {
                    this.$_swal({ icon: 'error', html: data.errors.map((err) => `<p>${ _locale(err.message).ucfirst() }</p>`).join('') })
                }
            })
        },
        setReservationSaleMode(reservationTimeId, mode) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            this.$store.commit('common/setModal', null);

            EcomService.setReservationSaleMode({
                productId: this.product.productId,
                mode,
                reservationTimeId
            })
            .then((response) => {
                const { data } = response;
                
                if (data.success) {
                    this.$store.dispatch('reservations/onDateChange', this.date);
                } else {
                    this.$_swal({ icon: 'error', title: data.message })
                }
            })
        },
        saveOrder() {
            const resourceHandler = this.$refs.resourceHandler;
            const shareOwnerEl = this.$refs.shareOwner;

            if (!this.stampsValid) {
                this.$_swal({ icon: 'error', title: _locale('not enough membership stamps for the whole reservation').ucfirst() })
                return false;
            }

            if (!this.activeReservation.recurringReservation &&
                (!resourceHandler.isMandatoryProductsSelected() ||
                !resourceHandler.isMandatoryResourcesSelected())) {
                this.$_swal({ icon: 'error', title: _locale('mandatory products are not set').ucfirst() })
                return false;
            }

            let rows = this.activeReservation.format();
            // no available minute options!
            if (this.$store.getters['reservations/minuteRules'].length && rows[0].fullDuration === 0) return;

            let additionalResources = [];
            let additionalResourceReservations = [];

            if (this.additionalReservations.length > 0) {
                this.additionalReservations.forEach((resObj) => {                  
                    rows = rows.concat(resObj.format())
                })
            }

            if (!this.activeReservation.recurringReservation
                && this.availableAdditionalResources.length > 0) {
                additionalResources = this.selectedAdditionalResources.filter(row => row.productType !== 6); // non reservations
                additionalResourceReservations = this.selectedAdditionalResources.filter(row => row.productType === 6);
            }
            
            let orderRows = rows.map((reservation, i) => {
                const row = {
                    productId: this.product.productId,
                    productVariantId: 0,
                    quantity: reservation.quantity * reservation.resources[0].quantity,
                    reservation
                }
                //console.log(reservation.resources);
                // additional resources disabled from recurring reservations for now
                // the resevation type product carries the resource detail
                // if the resource is a product, add it as a children cartproduct
                // this.additionalReservations.length === 0 
                if (!this.activeReservation.recurringReservation
                        && this.availableAdditionalResources.length > 0
                        && i === 0) {
                    if (additionalResources.length > 0) {
                        reservation.resources = [
                            ...reservation.resources,
                            ...additionalResources.map((resource) => ({
                                resourceId: resource.resourceId,
                                resourceName: resource.resourceName,
                                quantity: resource.orderQuantity,
                                option: resource.option,
                                productId: resource.productId,
                                personId: resource.personId
                            }))
                        ];

                        row.childrenProducts = additionalResources.map((resource) => ({
                            quantity: resource.orderQuantity,
                            productId: resource.productId,
                            productVariantId: 0
                        }))
                    }
                }

                if (this.stampsInUse) {
                    const stampCategoryId = Object.keys(this.membershipStampsQuantity)[0]
                    row.useStamps = this.membershipStamps.filter(row => row.categoryId == stampCategoryId)[0];
                }

                return row;
            })

            // add additionalResourceReservations as normal reservation rows
            // these are additional products that are type 6 (reservation)
            additionalResourceReservations.map((resource) => {
                const start = this.activeReservation.start.clone();
                // by default, use resource min duration (this was just implemented first)
                let end = start.clone().add(resource.productReservationMinDuration, 'minutes');
                let quantity = resource.productReservationMinDuration / resource.productReservationDuration;
                // also an option to use same duration as activeReservation
                if (resource.option == 2) {
                    end = this.activeReservation.end.clone();
                    quantity = durationToBlockCount(start, end, resource.productReservationDuration);
                }
                
                const reservation = {
                    reservationId: resource.productReservationId,
                    start: start.format('YYYY-MM-DD HH:mm:ss'),
                    end: end.format('YYYY-MM-DD HH:mm:ss'),
                    resources: [
                        {
                            resourceId: resource.resourceId,
                            quantity: resource.orderQuantity,
                            resourceName: resource.resourceName
                        }
                    ]
                }

                return {
                    quantity,
                    productId: resource.productId,
                    productVariantId: 0,
                    reservation
                };
            })
            .forEach(row => orderRows.push(row))
            
            const data = {
                products: orderRows
            }

            if (this.adminMode) {
                const selectedShareOwner = shareOwnerEl.getSelected();
                
                if (selectedShareOwner !== null) {
                    data.shareId = selectedShareOwner.shareId;
                }

                if (this.activeReservation.recurringReservation) {
                    data.recurringReservation = this.activeReservation.recurringReservation;
                }
            }
            /* This isn't needed when a reservation is sold, right?!
            if (this.activeReservation.soldReservationTimeId) {
                data.label = this.activeReservation.label;
                data.shareId = this.activeReservation.shareId;
            }
            */

            let gotoCheckout = true;
            
            this.$store.commit('common/setModal', null)
            
            if (this.adminMode) {
                data.forClient = true;

                return this.$_swal({
                    title: _locale('Proceed to checkout').ucfirst() + '?',
                    showCancelButton: true,
                    showDenyButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: _locale('Proceed to checkout').ucfirst(),
                    denyButtonText: _locale('add to cart').ucfirst(),
                    cancelButtonText: _locale('save order').ucfirst(),
                    didOpen: () => {
                        const swal = this.$_swalInstance.getPopup()
                        const closeBtn = document.createElement('button')
                        closeBtn.innerHTML = '&times;'
                        closeBtn.setAttribute('aria-label', _locale('close').ucfirst())
                        closeBtn.style.cssText = `
                            position: absolute;
                            top: 10px;
                            right: 15px;
                            font-size: 26px;
                            background: none;
                            border: none;
                            color: #737373;
                            cursor: pointer;
                        `;
                        closeBtn.addEventListener('click', () => {
                            this.$_swalInstance.close({ type: 'close' })
                        })
                        swal.appendChild(closeBtn)
                        swal.querySelector('h2').style.paddingBottom = '14px'
                    }
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.addToCart(data);
                    } else if (result.isDenied) {
                        this.addToCart(data, false);
                    } else if (result.isDismissed) {
                        // Swal is quite limited with buttons so we have to hack
                        // the close button above also fires isDismissed event
                        // custom argument "type" is defined in the close call above
                        if (result.type === 'close') {
                            return;
                        }
                        // default dismiss operation: save order :)
                        data.forceMockOrder = true;
                        this.createMockReservation(data);
                    }
                })
                
                /*
                // 20.12.2021 - always ask admin for proceeding
                if (this.$refs.priceSummary.getTotalPrice() > 0) {
                    
                } else {
                    gotoCheckout = false;
                }
                */
            } else if (this.$refs.priceSummary.getTotalPrice() === 0) {
                gotoCheckout = false;
            }
            
            if (gotoCheckout) {
                this.addToCart(data);
            } else {
                this.createMockReservation(data);
            }
        },
    }
}
</script>